"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _config = require("../config");
var _Translations = require("react-platform-components/dist/Translations");
var _ShoppingCart = _interopRequireDefault(require("@material-ui/icons/ShoppingCart"));
var _reactRouterDom = require("react-router-dom");
var _dompurify = _interopRequireDefault(require("dompurify"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    header: {
      backgroundColor: "#0a76a9",
      backgroundImage: "url(\"".concat(_config.STATIC_PATH, "/assets/images/backgrounds/header-bg.png\")"),
      backgroundSize: 'cover',
      color: '#fff',
      display: 'flex',
      height: '10vh',
      minHeight: '10vh'
    }
  };
});
function Subscriptions(props) {
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var history = (0, _reactRouterDom.useHistory)();
  var subscriptions = (0, _reactRedux.useSelector)(function (state) {
    return state.stripeSubscriptionsReducer.subscriptions;
  });
  (0, _react.useEffect)(function () {
    dispatch({
      type: 'FETCH_SUBSCRIPTIONS',
      params: {
        salable_item_class: _config.STRIPE_SUBSCRIPTION_SALABLE_ITEM_CLASS
      }
    });
  }, [dispatch]);
  var paySubscription = function paySubscription(subscription) {
    return function () {
      if (subscription.salable_item_options && subscription.salable_item_options.length > 0) {
        history.push("/subscriptions-products/".concat(subscription.uuid, "/").concat(subscription.salable_item_options[0].uuid), {
          subscription: subscription
        });
      } else {
        dispatch({
          type: 'PAY_SUBSCRIPTION',
          subscription: subscription,
          history: history
        });
      }
    };
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "p-12 pt-80 flex flex-1 flex-col items-center justify-center md:flex-row md:items-end ".concat(classes.header)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-1 flex-col items-center justify-center md:flex-row md:items-center md:justify-start white"
  }, /*#__PURE__*/_react.default.createElement(_ShoppingCart.default, {
    className: "md:mr-4"
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: "white",
    variant: "h5"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Les Abonnements",
    defaultMessage: "Les Abonnements"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex items-center justify-end"
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    xs: 12,
    md: 12,
    spacing: 3,
    className: "flex flex-wrap p-5"
  }, (subscriptions === null || subscriptions === void 0 ? void 0 : subscriptions.length) > 0 && subscriptions.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 4,
      lg: 3,
      key: index,
      className: "flex"
    }, /*#__PURE__*/_react.default.createElement(_core.Card, {
      elevation: 4,
      className: "w-full",
      style: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }
    }, /*#__PURE__*/_react.default.createElement(_core.CardHeader, {
      title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
        color: "secondary",
        variant: "h5",
        align: "center"
      }, item.name), /*#__PURE__*/_react.default.createElement("div", {
        className: "flex justify-center items-center mt-4"
      }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
        variant: "h5"
      }, item.price, " ", item.currency)))
    }), /*#__PURE__*/_react.default.createElement(_core.CardContent, null, /*#__PURE__*/_react.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: _dompurify.default.sanitize(item.description)
      }
    })), /*#__PURE__*/_react.default.createElement(_core.CardActions, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: "w-full",
      variant: "contained",
      color: "primary",
      size: "small",
      onClick: paySubscription(item)
    }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Buy",
      defaultMessage: "Buy"
    })))));
  })));
}
var _default = Subscriptions;
exports.default = _default;